import Nft from "../models/nft";

const NFTS = [
  new Nft(
    "0x495f947276749ce646f68ac8c248420045cb7b5e_3500790191281709115567938835922159689043824138506277840882321014095723102209",
    "Self-Portrait 1982 #1",
    "https://lh3.googleusercontent.com/koPaCnqx2YwcwhFIOPdPpKo9e-ogHbbo0XIEI1FNYrdiEsATTKY9kSCwJ_Dj1VKaW3qZwKd-1YktcXFaPF5izz4faht0JKqy-L1RHw",
    "Shane Guffogg",
    "Shane Guffogg",
    "ethereum",
    "0x495f947276749ce646f68ac8c248420045cb7b5e",
    "3500790191281709115567938835922159689043824138506277840882321014095723102209",
    ""
  ),

  new Nft(
    "0x495f947276749ce646f68ac8c248420045cb7b5e_3500790191281709115567938835922159689043824138506277840882321015195234729985",
    "Blue Self-Portrait",
    "https://lh3.googleusercontent.com/spYOOh7biTmpTKyULm8kgWZIBY9H-Xh9sKvbvgegzOgBTKSlds1vgCSvHz593i7oke-ll6rhwX9WaIB6Zda9YywKe9IFUlJ6TuabBQ",
    "Shane Guffogg",
    "Shane Guffogg",
    "ethereum",
    "0x495f947276749ce646f68ac8c248420045cb7b5e",
    "3500790191281709115567938835922159689043824138506277840882321015195234729985",
    "https://lh3.googleusercontent.com/spYOOh7biTmpTKyULm8kgWZIBY9H-Xh9sKvbvgegzOgBTKSlds1vgCSvHz593i7oke-ll6rhwX9WaIB6Zda9YywKe9IFUlJ6TuabBQ"
  ),

  new Nft(
    "p5",
    "Dr. Strangelove",
    "https://lh3.googleusercontent.com/4ucghNvSNY64skePUQt3TePkU0D28w5AcNo0mRU-5hmPgWVMH4zmGenuUVV4JO-KSRUUO8m0Ua-yoUob9F9_LvA1enilpYpyy5GT=s0",
    "Tom Sachs Rocket Factory",
    "Tom Sachs Rocket Factory",
    "ethereum",
    "0x6B00de202e3Cd03c523CA05d8b47231DBdD9142b",
    "460",
    ""
  ),
  new Nft(
    "p0",
    "Banksy Punk #40",
    "https://lh3.googleusercontent.com/_I4sO29KGfrr4hO1y9xrS_OWL7NmRzKzWkx51256xQR7M7zzVgWBder_eMEYO1kcistJN8YKFOETVbXhnM6m8utelc44xq9ahvpGS_o=s0",
    "BanksysBank",
    "BanksysBank",
    "Polygon",
    "0x2953399124f0cbb46d2cbacd8a89cf0599974963",
    "88371413974025429861395935665136765738837057507277374313264107307143081754644",
    ""
  ),

  new Nft(
    "0x495f947276749ce646f68ac8c248420045cb7b5e_3500790191281709115567938835922159689043824138506277840882321016294746357761",
    "Self-Portrait 1982 #2",
    "https://storage.opensea.io/files/f16a94c172a828259b2ec1148cfc364b.mp4",
    "Shane Guffogg",
    "Shane Guffogg",
    "ethereum",
    "0x495f947276749ce646f68ac8c248420045cb7b5e",
    "3500790191281709115567938835922159689043824138506277840882321016294746357761",
    "https://lh3.googleusercontent.com/YN3nLfv6T283GvvKzTdYIs_s9CyAAM-atG941yEAS4kK3C6aZg46oTGREkpqWyk995aQ24TUXhiP0Arh8mAvlP-aLMYDqPkogoXisg",
    // "",
    "",
    "",
    "https://storage.opensea.io/files/f16a94c172a828259b2ec1148cfc364b.mp4"
  ),
  // Nft {
  //   "animationUrl": "https://storage.opensea.io/files/f16a94c172a828259b2ec1148cfc364b.mp4",
  //   "artist": "Shane Guffogg",
  //   "blockchain": "Ethereum",
  //   "collection": "Shane Guffogg",
  //   "collectionImageUrl": null,
  //   "contractAddr": "0x495f947276749ce646f68ac8c248420045cb7b5e",
  //   "id": "0x495f947276749ce646f68ac8c248420045cb7b5e_3500790191281709115567938835922159689043824138506277840882321016294746357761",
  //   "imageOriginalUrl": null,
  //   "imageThumbnailUrl": "https://lh3.googleusercontent.com/YN3nLfv6T283GvvKzTdYIs_s9CyAAM-atG941yEAS4kK3C6aZg46oTGREkpqWyk995aQ24TUXhiP0Arh8mAvlP-aLMYDqPkogoXisg=s128",
  //   "imageUrl": "https://lh3.googleusercontent.com/YN3nLfv6T283GvvKzTdYIs_s9CyAAM-atG941yEAS4kK3C6aZg46oTGREkpqWyk995aQ24TUXhiP0Arh8mAvlP-aLMYDqPkogoXisg",
  //   "title": "Self-Portrait 1982 #2",
  //   "tokenId": "3500790191281709115567938835922159689043824138506277840882321016294746357761",
  // },

  // new Nft(
  //   "p9",
  //   "Dancer",
  //   "https://authentik-website.web.app/assets/shane_5.jpg",
  //   "Shane Guffogg",
  //   "Shane Guffogg",
  //   "ethereum",
  //   "0x495f947276749ce646f68ac8c248420045cb7b5e",
  //   "88371413974025429861395935665136765738837057507277374313264107307143081754644",
  //   "https://authentik-website.web.app/assets/shane_5.jpg"
  // ),

  // new Nft(
  //   "p10",
  //   "Eyes",
  //   "https://authentik-website.web.app/assets/shane_7.jpg",
  //   "Shane Guffogg",
  //   "Shane Guffogg",
  //   "ethereum",
  //   "0x495f947276749ce646f68ac8c248420045cb7b5e",
  //   "88371413974025429861395935665136765738837057507277374313264107307143081754644",
  //   "https://authentik-website.web.app/assets/shane_7.jpg"
  // ),
  new Nft(
    "p2",
    "Crypto Chick #2219",
    "https://lh3.googleusercontent.com/wH_WTKE765uO-pEZE_nPqBBXAQ4c-CPVZWkdSW27oxM30eZiZQlS6jLv4k9NUaooSjlFa9oDhvdPW3e9ZI6WG1HN2cDuFMAF_66t",
    "Crypto.Chicks",
    "Crypto.Chicks",
    "ethereum",
    "0x1981cc36b59cffdd24b01cc5d698daa75e367e04",
    "2219",
    ""
  ),
  // new Nft(
  //   "p3",
  //   "Streak",
  //   "https://lh3.googleusercontent.com/3nnEfEYlb_sgr5XwTlGQWVcg9LLzuVFGpvw1uq2hqMkj6hZjaKq-BFnUqDqUEh841DMFAokd-UO_GfCdwObmtu9R-ya0pSpFjaL9soI=s0",
  //   "JoeyKhamis",
  //   "Gravity Footwear",
  //   "ethereum",
  //   "0x495f947276749ce646f68ac8c248420045cb7b5e",
  //   "7510645868949939307469821048409831781729876581445086497591589719199266635777",
  //   ""
  // ),
  new Nft(
    "0xc7d84b7d4a04abcb9ade97b8af212423f51d2aea_301",
    "GEMMA #301",
    "https://lh3.googleusercontent.com/G5zok_RmtcOizp5nzIno-CUFf6qMsrJjHvnE20ktHN3lpB3w0zwJT0PmrfKVEROZ8YxaD7Ae5JSa6fn1zTCYzOGBDwlo_mxp8CqtQw",
    "GEMMA",
    "GEMMA BY TRISTAN EATON",
    "ethereum",
    "0xc7d84b7d4a04abcb9ade97b8af212423f51d2aea",
    "301",
    ""
  ),
  // Nft {
  //   "animationUrl": null,
  //   "artist": "GEMMA BY TRISTAN EATON",
  //   "blockchain": "Ethereum",
  //   "collection": "GEMMA BY TRISTAN EATON",
  //   "collectionImageUrl": "https://lh3.googleusercontent.com/FeqZQ2fAjaNqCrxpz2x9ZlNR9PXAP6Ok-lwnaX6ti-BomzyEKmnslCZorU1-aKWM_zq6Mop7RJHT_YqVEKBXh9PIOEciNlxnQYjl=s120",
  //   "contractAddr": "0xc7d84b7d4a04abcb9ade97b8af212423f51d2aea",
  //   "id": "0xc7d84b7d4a04abcb9ade97b8af212423f51d2aea_301",
  //   "imageOriginalUrl": "https://ipfs.io/ipfs/QmUjGTEirKvrLhdjthpHxMD91WkzJ8vjsZCSCo89RmqyCC/5db7f725ba439a7dfcc22910ead29149ff7eb24c6e402bae39bbca12ec59f52b.jpg",
  //   "imageThumbnailUrl": "https://lh3.googleusercontent.com/G5zok_RmtcOizp5nzIno-CUFf6qMsrJjHvnE20ktHN3lpB3w0zwJT0PmrfKVEROZ8YxaD7Ae5JSa6fn1zTCYzOGBDwlo_mxp8CqtQw=s128",
  //   "imageUrl": "https://lh3.googleusercontent.com/G5zok_RmtcOizp5nzIno-CUFf6qMsrJjHvnE20ktHN3lpB3w0zwJT0PmrfKVEROZ8YxaD7Ae5JSa6fn1zTCYzOGBDwlo_mxp8CqtQw",
  //   "title": "GEMMA #301",
  //   "tokenId": "301",
  // },
  new Nft(
    "p4",
    "Spring Garden",
    "https://lh3.googleusercontent.com/D4z60syrwAJLUEPetTdOY1PU8kRUQswj3tp0sFrewTr_waaA8EOAle0kgUHBv91uuyMxl5vpnymltFTglpuj0VBZitOWndojIrmDHg=s0",
    "SoulCurryArt",
    "SoulCurryArt",
    "ethereum",
    "0x495f947276749ce646f68ac8c248420045cb7b5e",
    "93281785975417662181072555544922004567407315035659333894901814603477636087809",
    ""
  ),
];

export default NFTS;
